module.exports = __webpack_public_path__ + "static/faq-box-1-1-409ee216958546d1d91643caf0ca306b.jpg";